import { render } from "./AnalyticsNotesForeignTradeTextWrapper.vue?vue&type=template&id=09c0ba6e&scoped=true&ts=true"
import script from "./AnalyticsNotesForeignTradeTextWrapper.vue?vue&type=script&lang=ts"
export * from "./AnalyticsNotesForeignTradeTextWrapper.vue?vue&type=script&lang=ts"

import "./AnalyticsNotesForeignTradeTextWrapper.vue?vue&type=style&index=0&id=09c0ba6e&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09c0ba6e"]])

export default __exports__